import React from "react";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import { convertThenFormat, formattedAmount } from "../../../common-data/Converts";

const TEPLargeCard = (props) => {
  const {
    filterType,
    cardTitle,
    onClickCard,
    cardName,
    baseSalary,
    rewards,
    renewals,
    penalty,
    targetAssigned,
    targetAchieved,
    checkinsPer,
    missedCheckinsPer,
    totalCheckins,
    lateCheckins,
    totalOnTimeCheckins,
    occupationPer,
    totalSlots,
    availSlots,
    bookedSlots,
    rating,
    pts,
    regulars,
    addons,
    // goalFocus,
    totalTrainers,
    totalSalaryExpense,
    avgSaleValue,
    roi,
    isLoading,
    isAdmin,
    totalMembersData,
    targetValues,
  } = props || {};

  const { total_pt_price, total_addon_price, total_regular_price } =
    totalMembersData || {};

  const { addon_pt, regular, addon } = targetValues || {};

  let canClick;
  if (isLoading) {
    canClick = false;
  }
  // else if (filterType === "tsar") {
  //   canClick = false;
  // }
  else if (filterType === "ratings") {
    canClick = false;
  } else if (isAdmin && filterType === "monthly_target") {
    canClick = false;
  } else {
    canClick = true;
  }

  return (
    <div
      className={`cards-child`}
      onClick={() => (canClick ? onClickCard(filterType) : null)}
      style={{
        cursor: !canClick ? "not-allowed" : "pointer",
      }}
    >
      <div className="cards-heading">
        <span className="label-name">{cardTitle}</span>
      </div>
      {isLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-labels">
          {cardName === "trainer-details" ? (
            <div className="card-value-list">
              {(baseSalary || baseSalary === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{baseSalary} </p>
                  <span className="light-tag">base salary</span>
                </div>
              )}

              {(rewards || rewards === 0) && (
                <div className="name-value">
                  <p className="label-value green">+ ₹{rewards}</p>
                  <span className="light-tag">rewards</span>
                </div>
              )}

              {(renewals || renewals === 0) && (
                <div className="name-value">
                  <p className="label-value green">+ ₹{renewals}</p>
                  <span className="light-tag">renewals</span>
                </div>
              )}

              {(penalty || penalty === 0) && (
                <div className="name-value">
                  <p className="label-value red">- ₹{penalty}</p>
                  <span className="light-tag">penalty</span>
                </div>
              )}

              {(targetAssigned || targetAssigned === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{targetAssigned} </p>
                  <span className="light-tag">Target Assigned</span>
                </div>
              )}

              {targetAssigned ? (
                <div className="name-value">
                  <p className="label-value">₹{addon_pt || 0} </p>
                  <span className="light-tag">PT</span>
                </div>
              ) : null}

              {targetAssigned ? (
                <div className="name-value">
                  <p className="label-value">₹{addon || 0} </p>
                  <span className="light-tag">Addon</span>
                </div>
              ) : null}

              {targetAssigned ? (
                <div className="name-value">
                  <p className="label-value">₹{regular || 0} </p>
                  <span className="light-tag">Regular</span>
                </div>
              ) : null}

              {(targetAchieved || targetAchieved === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{targetAchieved} </p>
                  <span className="light-tag">Target Achieved</span>
                </div>
              )}

              {(totalTrainers || totalTrainers === 0) && (
                <div className="name-value">
                  <p className="label-value">{totalTrainers} </p>
                  <span className="light-tag">Total PT Trainers</span>
                </div>
              )}

              {(totalSalaryExpense || totalSalaryExpense === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{formattedAmount(totalSalaryExpense)} </p>
                  <span className="light-tag">Salaries Expense</span>
                </div>
              )}

              {(avgSaleValue || avgSaleValue === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{avgSaleValue}</p>
                  <span className="light-tag">Average Sale Value</span>
                </div>
              )}

              {(roi || roi === 0) && (
                <div className="name-value">
                  <p
                    className={`label-value ${parseInt(roi) < 0 ? "red" : ""}`}
                  >
                    {roi}%
                  </p>
                  <span className="light-tag">ROI</span>
                </div>
              )}

              {(totalCheckins || totalCheckins === 0) && (
                <div className="name-value">
                  <p className="label-value">{totalCheckins}</p>
                  <span className="light-tag">Total Checkin</span>
                </div>
              )}

              {(totalOnTimeCheckins || totalOnTimeCheckins === 0) && (
                <div className="name-value">
                  <p className="label-value">{totalOnTimeCheckins} </p>
                  <span className="light-tag">On Time Checkin</span>
                </div>
              )}

              {(lateCheckins || lateCheckins === 0) && (
                <div className="name-value">
                  <p className="label-value">{lateCheckins}</p>
                  <span className="light-tag">Late Checkin</span>
                </div>
              )}

              {(checkinsPer || checkinsPer === 0) && (
                <div className="name-value">
                  <p className="label-value">{checkinsPer}% </p>
                  <span className="light-tag">Checkin percentage</span>
                </div>
              )}

              {(missedCheckinsPer || missedCheckinsPer === 0) && (
                <div className="name-value">
                  <p className="label-value">{missedCheckinsPer}% </p>
                  <span className="light-tag">Missed Checkin percentage</span>
                </div>
              )}

              {(occupationPer || occupationPer === 0) && (
                <div className="name-value">
                  <p className="label-value">{occupationPer}%</p>
                  <span className="light-tag">Occupied</span>
                </div>
              )}

              {(totalSlots || totalSlots === 0) && (
                <div className="name-value">
                  <p className="label-value">{totalSlots} </p>
                  <span className="light-tag">Total Slots</span>
                </div>
              )}

              {(availSlots || availSlots === 0) && (
                <div className="name-value">
                  <p className="label-value">{availSlots} </p>
                  <span className="light-tag">Total Available Slots</span>
                </div>
              )}

              {(bookedSlots || bookedSlots === 0) && (
                <div className="name-value">
                  <p className="label-value">{bookedSlots} </p>
                  <span className="light-tag">Total Booked Slots</span>
                </div>
              )}

              {(rating || rating === 0) && (
                <div className="name-value">
                  <p className="label-value">{rating}</p>
                  <span className="light-tag">Overall Rating</span>
                </div>
              )}

              {(pts || pts === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{convertThenFormat(total_pt_price || 0)}</p>
                  <span className="light-tag">PT ({pts} Members)</span>
                </div>
              )}

              {(regulars || regulars === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{convertThenFormat(total_regular_price || 0)}</p>
                  <span className="light-tag">
                    regular ({regulars} Members)
                  </span>
                </div>
              )}

              {(addons || addons === 0) && (
                <div className="name-value">
                  <p className="label-value">₹{convertThenFormat(total_addon_price || 0)}</p>
                  <span className="light-tag">addon ({addons} Members)</span>
                </div>
              )}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default TEPLargeCard;
